import React, { useState } from 'react';
import { Button, Form, Header, InputOnChangeData, Segment } from 'semantic-ui-react';
import { IPasswordResetCredentilas } from '../../../types/auth';

interface Props {
  forgetPassword: (forgetPass: IPasswordResetCredentilas) => void;
  resetPassword: (route: string) => void;
  resetConfObj: IPasswordResetCredentilas
}

export const ForgetPasswordComponent = (props: Props): JSX.Element => {

  const [resetConf, setForgetPassword] = useState<IPasswordResetCredentilas>({
    password: props.resetConfObj.password,
    uidb64: props.resetConfObj.uidb64,
    token: props.resetConfObj.token,
    passwordTwo: props.resetConfObj.passwordTwo
  })

  const [passwordError, setPwdError] = useState('')

  const handleChangePassword = (data: InputOnChangeData) => {
    const _resetConf = { ...resetConf, password: data.value }
    setForgetPassword(_resetConf)
    setPwdError(resetConf.passwordTwo !== data.value ? 'Passwords are not the same.' : data.value.length < 6 ? 'Password must contain at least 6 characters.' : '')
  }

  const handleChangeSecondPassword = (data: InputOnChangeData) => {
    const _resetConf = { ...resetConf, passwordTwo: data.value }
    setForgetPassword(_resetConf)
    setPwdError(resetConf.password !== data.value ? 'Passwords are not the same.' : data.value.length < 6 ? 'Password must contain at least 6 characters.' : '')
  }

  const handleRequestEmail = () => {
    props.forgetPassword(resetConf)
  }

  return (
    <Segment style={{ border: 'none', background: 'white', height: '45rem', width: '39.3rem', borderRadius: '8px', boxShadow: '0 0 25px -5px rgba(21,21,21,0.1)' }}>
      <Header textAlign='left' style={{ padding: '3rem', fontSize: '2.5rem' }}>
        New password
        <Header.Subheader style={{ color: '#BEC8C3', fontSize: '1.125rem', marginTop: '1rem' }}>Please enter your new password.</Header.Subheader>
      </Header>
      <Form size='large' style={{ textAlign: 'left', padding: '0 3rem 3rem 3rem' }}>
        <label style={{ fontWeight: 500, textAlign: 'left', color: '#747678', fontSize: '1.125rem', paddingBottom: '1rem' }}>New password</label>
        <Form.Input
          labelPosition='left'
          style={{ borderRadius: '8px', marginTop: '1rem' }}
          fluid={true}
          icon='lock'
          size='large'
          iconPosition='left'
          type='password'
          placeholder='Password'
          onChange={(e, data) => { handleChangePassword(data) }}
        />
        <label style={{ fontWeight: 500, textAlign: 'left', color: '#747678', fontSize: '1.125rem', paddingBottom: '1rem' }}>Repeat password</label>
        <Form.Input
          labelPosition='left'
          style={{ borderRadius: '8px', marginTop: '1rem' }}
          fluid={true}
          icon='lock'
          size='large'
          iconPosition='left'
          type='password'
          placeholder='Repeat password'
          onChange={(e, data) => { handleChangeSecondPassword(data) }}
        />
        {passwordError &&
            <label style={{ fontWeight: 500, textAlign: 'left', color: '#FA5953', fontSize: '1.125rem', paddingBottom: '1rem' }}>{passwordError}</label>}
        <Button
          disabled={passwordError !== ''}
          primary
          fluid
          onClick={() => handleRequestEmail()}
          content='Save'
          style={{ marginTop: '2rem', height: '50px', borderRadius: '8px', padding: 0, fontSize: '18px', lineHeight: '21px', letterSpacing: '0.25px' }}
        />
      </Form>
    </Segment>
  )
}

export default ForgetPasswordComponent
